import BeneficiaryMessageComponent from 'components/Admin/BeneficiaryMessageComponent/BeneficiaryMessageComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';

function BeneficiaryMessage() {
  return (
    <div className="beneficiary-message layout-full-height">
      <Header />

      <ContainerComponent className="layout-main-content">
        <BeneficiaryMessageComponent />
      </ContainerComponent>

      <Footer />
    </div>
  );
}

export default BeneficiaryMessage;
